if (typeof CollectionTabs !== 'function') {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
    }

    connectedCallback() {
      // Wait for DOM to be fully ready before initializing
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        // Small delay to ensure children are parsed
        requestAnimationFrame(() => this.init());
      }
    }

    init() {
      if (this._initialized) return;
      this._initialized = true;
      
      this.tabs = this.querySelectorAll('.collection-tabs_tab');
      this.panels = this.querySelectorAll('.collection-tabs_panel');
      this.viewCollectionLink = this.querySelector('.section-heading__actions a');
      this.viewCollectionLink2 = this.querySelector('.js-view-collection-link');

      if (!this.tabs.length || !this.panels.length) return;

      // Bind click handlers to tabs and their buttons
      this.tabs.forEach((tab, index) => {
        // Click on the tab (li element)
        tab.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.activateTab(index);
        };

        // Also bind to the button inside
        const button = tab.querySelector('button');
        if (button) {
          button.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.activateTab(index);
          };
        }
      });

      // Ensure first tab and panel are active on load
      this.syncInitialState();
    }

    syncInitialState() {
      // Find if any tab is already marked active
      let activeIndex = -1;
      this.tabs.forEach((tab, index) => {
        if (tab.classList.contains('active')) {
          activeIndex = index;
        }
      });

      // If no tab is active, activate the first one
      if (activeIndex === -1 && this.tabs.length > 0) {
        activeIndex = 0;
      }

      if (activeIndex >= 0) {
        this.activateTab(activeIndex);
      }
    }

    activateTab(index) {
      const targetTab = this.tabs[index];
      if (!targetTab) return;

      // Deactivate all tabs
      this.tabs.forEach((tab) => {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
        const btn = tab.querySelector('button');
        if (btn) {
          btn.setAttribute('aria-selected', 'false');
        }
      });

      // Hide all panels
      this.panels.forEach((panel) => {
        panel.classList.remove('active');
        panel.setAttribute('aria-hidden', 'true');
      });

      // Activate the target tab
      targetTab.classList.add('active');
      targetTab.setAttribute('aria-selected', 'true');

      const targetButton = targetTab.querySelector('button');
      if (targetButton) {
        targetButton.setAttribute('aria-selected', 'true');

        // Get the panel ID from aria-controls
        const panelId = targetButton.getAttribute('aria-controls');
        
        // Update collection links if present
        const collectionUrl = targetButton.getAttribute('data-collection-url');
        if (this.viewCollectionLink && collectionUrl) {
          this.viewCollectionLink.setAttribute('href', collectionUrl);
        }
        if (this.viewCollectionLink2 && collectionUrl) {
          this.viewCollectionLink2.setAttribute('href', collectionUrl);
        }

        // Activate the corresponding panel
        if (panelId) {
          const targetPanel = this.querySelector(`#${panelId}`);
          if (targetPanel) {
            targetPanel.classList.add('active');
            targetPanel.setAttribute('aria-hidden', 'false');
            
            // Reset any slider in the panel
            const slider = targetPanel.querySelector('css-slider');
            if (slider && typeof slider.resetSlider === 'function') {
              slider.resetSlider();
            }
          }
        }
      }
    }
  }

  if (typeof customElements.get('collection-tabs') === 'undefined') {
    customElements.define('collection-tabs', CollectionTabs);
  }

  // Re-init on Shopify section reload
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('mount-collection-tabs')) {
      const tabsElement = e.target.querySelector('collection-tabs');
      if (tabsElement) {
        tabsElement._initialized = false;
        tabsElement.init();
      }
    }
  });
}

// Fallback: Re-initialize any collection-tabs on the page after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('collection-tabs').forEach((el) => {
    if (!el._initialized) {
      el.init();
    }
  });
});
